<script setup>
import { inject, computed } from 'vue'
import { usePage } from '@inertiajs/vue3'

const __t = inject('__t')
const page = usePage()
const isRtl = computed(() => page.props.locale === 'ar')

const nextSteps = [
    __t('home_next_steps_item_1'),
    __t('home_next_steps_item_2'),
    __t('home_next_steps_item_3'),
    __t('home_next_steps_item_4'),
    __t('home_next_steps_item_5'),
]
</script>

<template>
    <section class="">
        <div class="w-full">
            <!-- Full Width Container with subtle side margin on large screens if desired, but here we go edge-to-edge -->
            <div class="relative bg-primary overflow-hidden shadow-2xl" data-aos="fade-up">
                <!-- Background Decorative Glow -->
                <div class="absolute top-0 right-0 w-full h-full pointer-events-none opacity-20">
                    <div class="absolute -top-1/4 -right-1/4 w-[60rem] h-[60rem] bg-white rounded-full blur-[15rem]">
                    </div>
                </div>

                <div class="relative z-10 flex flex-col lg:flex-row items-stretch">

                    <!-- Content Side: Takes more space and is centered vertically -->
                    <div class="w-full lg:w-7/12 p-8 md:p-16 lg:p-24 flex flex-col justify-center"
                        :class="isRtl ? 'text-right order-first' : 'text-left order-first'">
                        <div class="max-w-4xl space-y-12">
                            <!-- Title & Subtitle Group -->
                            <div class="space-y-8">
                                <h2 class="text-3xl md:text-5xl lg:text-5xl font-black text-white leading-[1.1] tracking-tighter"
                                    data-aos="fade-up">
                                    {{ __t('home_next_steps_title') }}
                                </h2>

                                <div class="inline-flex items-center gap-5 bg-white/10 backdrop-blur-xl border border-white/20 px-8 py-5 rounded-[2rem] shadow-xl"
                                    data-aos="fade-up" data-aos-delay="200">
                                    <div class="flex flex-col gap-2">
                                        <div v-for="i in 3" :key="i" class="w-4 h-1 bg-white rounded-full opacity-70">
                                        </div>
                                    </div>
                                    <p class="font-black text-xl md:text-xl text-white">
                                        {{ __t('home_next_steps_subtitle') }}
                                    </p>
                                </div>
                            </div>

                            <!-- List of Goals: Two-column grid on desktop for better space usage if needed, or single column for impact -->
                            <div class="grid grid-cols-1 gap-6 md:gap-8 pt-6">
                                <div v-for="(item, index) in nextSteps" :key="index"
                                    class="flex items-center gap-6 group" data-aos="fade-up"
                                    :data-aos-delay="400 + (index * 100)">
                                    <div
                                        class="flex-shrink-0 w-10 h-10 md:w-10 md:h-10 rounded-2xl bg-white text-[#1E5AF9] flex items-center justify-center shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 md:w-6 md:h-6"
                                            fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="4"
                                                d="M5 13l4 4L19 7" />
                                        </svg>
                                    </div>
                                    <span
                                        class="text-xl md:text-xl font-black text-white/90 group-hover:text-white transition-colors duration-300 leading-tight">
                                        {{ item }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Image Side: Full height on large screens -->
                    <div class="w-full lg:w-5/12 relative flex items-center justify-center  px-8 py-16 lg:p-0"
                        data-aos="zoom-in" data-aos-delay="300">

                        <!-- Main 3D Steps Image -->
                        <img src="/assets/almatin/11 (1).png"
                            class="w-full max-w-[40rem] h-auto object-contain drop-shadow-[0_35px_35px_rgba(0,0,0,0.5)] transform hover:scale-105 transition-transform duration-1000"
                            alt="Al Matin Next Steps" />


                    </div>

                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
/* Custom styles if needed beyond Tailwind */
section {
    position: relative;
    z-index: 5;
}
</style>
